/**
 * Type definitions for assets exported in website FLibs
 * @typedef {Object} AssetsExport
 * @property {string} logo
 */

/**
 * @typedef {Object} LocalStorageService
 * @property {<ValueType>(key: string, defaultValue: ValueType) => ValueType} getValue
 * @property {<ValueType>(key: string, valueGetter: React.SetStateAction<ValueType>, defaultValue: ValueType, emit?: boolean) => void} setValue
 * @property {(key: string, emit?: boolean) => void} removeValue
 * @property {<PrevValue, NewValue>(key: string, transformValue: NewValue | ((oldValue: PrevValue | NewValue) => NewValue), defaultValue: NewValue) => void} migrateValue
 */

/**
 * Type definitions for functions exported in website FLibs
 * @typedef {Object} FLibsExport
 * @property {AssetsExport} assets
 * @property {(date?: Date, format?: TimeFormatType) => string} getFormattedDateString
 * @property {(date: Date) => string} formatDateToStringUS
 * @property {<ValueType>(key: string, defaultValue: ValueType) => ({ state: ValueType, setState: (value: React.SetStateAction<ValueType>) => void })} useSyncLocalStorage
 * @property {(props: { trackInitial?: boolean; trackAutomatically?: boolean; }) => () => void} useTrackPageView
 * @property {LocalStorageService} localStorage
 */

/**
 * Add type so that the properties are suggested
 * @type {FLibsExport}
 */
const FLibsExports = window.FLibs

module.exports = FLibsExports
